exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-details[data-v-184dab64]{display:flex;flex-wrap:wrap;align-items:flex-start;margin:-1rem -1rem 1rem}.category-details .category-img[data-v-184dab64]{padding:1rem;flex:1 1 max(100px,25%);border-radius:5px;overflow:hidden}.category-details .category-img img[data-v-184dab64]{width:100%;height:auto;vertical-align:bottom}.category-details .category-content[data-v-184dab64]{padding:1rem;flex:1 1 75%}", ""]);

// exports
